import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import {
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Portlet, PortletContent } from '../../../../../components';
import ParceirosParametrosTablePagination from './ParceirosParametrosTablePagination';
import { ParceirosTableRow } from './ParceirosTableRow';
import { ParceirosTableRowStyles } from '../Parceiros.style';
import TableColumnSortButton from '../../../../../theme/components/TableColumnSortButton/TableColumnSortButton';

const useStyles = makeStyles(ParceirosTableRowStyles);

export default function ParceirosParametrosTable(props) {
  const classes = useStyles(props);
  const {
    data: invoices,
    total,
    currentPage,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    setSorts,
    sorts,
    refetch,
  } = props;

  const rootClassName = cls(classes.root);

  return (
    <Portlet className={rootClassName}>
      <PortletContent noPadding>
        <TableContainer className={classes.tableContainer}>
          <Table width="100%" className={classes.mainTable}>
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.rowShadow}>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">
                    Parceiro
                    <TableColumnSortButton
                      value={sorts?.partner || ''}
                      onChange={sort => setSorts({ partner: sort })}
                    />
                  </Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Número PO</Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">
                    Status OC
                    <TableColumnSortButton value={sorts?.status || ''} onChange={sort => setSorts({ status: sort })} />
                  </Typography>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Status Oracle</Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">
                    Valor comissão
                    <TableColumnSortButton value={sorts?.amount || ''} onChange={sort => setSorts({ amount: sort })} />
                  </Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Mês competência</Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Data da Emissão</Typography>
                </TableCell>

                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Pagamento</Typography>
                </TableCell>

                <TableCell colSpan={2} className={classes.tableCell}>
                  <Typography variant="body2">Nota Fiscal</Typography>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {!invoices && (
                <TableRow width="100%" className={classes.tr}>
                  <TableCell className={classes.tableCell} width="100%">
                    Ops. Não encontramos nada.
                  </TableCell>
                </TableRow>
              )}
              {invoices.map(row => {
                return (
                  <ParceirosTableRow
                    key={row.id}
                    invoicesData={row}
                    classes={classes}
                    refetch={refetch}
                    parcelasFilter={props.parcelasFilter}
                  />
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={total}
                  page={currentPage - 1}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Registros por página"
                  onPageChange={() => {}}
                  ActionsComponent={() => (
                    <ParceirosParametrosTablePagination
                      total={total}
                      onChangePage={handleChangePage}
                      page={currentPage}
                      rowsPerPage={rowsPerPage}
                      refetch={refetch}
                    />
                  )}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </PortletContent>
    </Portlet>
  );
}

ParceirosParametrosTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
};
